module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    directives: [{
      name: "async",
      rawName: "v-async",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "col-md-2 first-col-box"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), (_vm.sameTax) ? _c('div', {
    staticClass: "height-100"
  }, [_c('p', {
    staticClass: "bold no-margin padding-28"
  }, [_vm._v("Adesão por Veículo")])]) : _vm._e(), _vm._v(" "), (!_vm.sameTax) ? _c('div', {
    staticClass: "height-82"
  }, [_c('p', {
    staticClass: "bold no-margin padding-12"
  }, [_vm._v("Adesão Primeiro Veículo")])]) : _vm._e(), _vm._v(" "), (!_vm.sameTax) ? _c('div', {
    staticClass: "height-82"
  }, [_c('p', {
    staticClass: "bold no-margin padding-12"
  }, [_vm._v("\n                Adesão Veículo Adicional\n              ")])]) : _vm._e(), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "height-72 border-radius-bottom",
    staticStyle: {
      "height": "82px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "plain-box"
  }, [_c('div', {
    staticClass: "row"
  }, [(!_vm.rodosol) ? _c('div', {
    staticClass: "col-md-6 small-padding-right"
  }, [_c('div', {
    staticClass: "second-col-box margin-b20"
  }, [_vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), (_vm.sameTax) ? _c('div', {
    staticClass: "height-100 padding-28"
  }, [_c('p', {
    staticClass: "mob-title-info"
  }, [_vm._v("Adesão por Veículo")]), _vm._v(" "), (1 == 1) ? _c('span', [(_vm.newAhesionTaxCont > 0) ? _c('h3', {
    staticClass: "bold no-margin margin-b10"
  }, [_vm._v("\n                        " + _vm._s(_vm._f("cents")(_vm.newAhesionTaxCont)) + "\n                      ")]) : _vm._e(), _vm._v(" "), (_vm.newAhesionTaxCont > 0) ? _c('small', [_vm._v("*Descontos vigentes aparecerão somente ao final da\n                        compra.")]) : (1 == 1) ? _c('span', [_c('h4', {
    staticClass: "promo-value margin-b10"
  }, [_vm._v("R$ 39,9099*")]), _vm._v(" "), _c('b', {
    staticClass: "promo-free"
  }, [_vm._v("Grátis")])]) : _vm._e()]) : _c('span', [_c('h1', {
    staticClass: "bold no-margin margin-b10"
  }, [_vm._v("Grátis")])])]) : _vm._e(), _vm._v(" "), (!_vm.sameTax) ? _c('div', {
    staticClass: "height-82 padding-28"
  }, [_c('p', {
    staticClass: "mob-title-info"
  }, [_vm._v("Adesão Primeiro Veículo")]), _vm._v(" "), _c('h3', {
    staticClass: "bold no-margin"
  }, [_vm._v("\n                      " + _vm._s(_vm._f("cents")(_vm.newAhesionTaxCont)) + "\n                    ")])]) : _vm._e(), _vm._v(" "), (!_vm.sameTax) ? _c('div', {
    staticClass: "height-82 padding-28"
  }, [_c('p', {
    staticClass: "mob-title-info"
  }, [_vm._v("Adesão Veículo Adicional")]), _vm._v(" "), _c('h3', {
    staticClass: "bold no-margin"
  }, [_vm._v("\n                      " + _vm._s(_vm._f("cents")(_vm.newVehicleTaxCont)) + "\n                    ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "height-72 padding-t25"
  }, [_c('a', {
    directives: [{
      name: "smooth-scroll",
      rawName: "v-smooth-scroll"
    }],
    staticClass: "make-link",
    attrs: {
      "href": "#rechargeB2B"
    }
  }, [_vm._v("\n                      Veja Nossas Taxas de Recarga\n                    ")])]), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "row-button border-radius-bottom"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "tag": "button"
    },
    on: {
      "click": function($event) {
        return _vm.choose(21)
      }
    }
  }, [_vm._v("\n                      Quero este plano!\n                    ")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "small-padding-left",
    class: _vm.rodosol ? '' : 'col-md-6'
  }, [_c('div', {
    staticClass: "third-col-box margin-b20"
  }, [_vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), (_vm.sameTax) ? _c('div', {
    staticClass: "height-100 padding-28"
  }, [_c('p', {
    staticClass: "mob-title-info"
  }, [_vm._v("Adesão por Veículo")]), _vm._v(" "), (!_vm.checkPromoSenff) ? _c('span', [(_vm.newAhesionTaxCont > 0) ? _c('h3', {
    staticClass: "bold no-margin margin-b10"
  }, [_vm._v("\n                        " + _vm._s(_vm._f("cents")(_vm.newAhesionTaxCont)) + "\n                      ")]) : _vm._e(), _vm._v(" "), (_vm.newAhesionTaxCont > 0) ? _c('small', [_vm._v("*Descontos vigentes aparecerão somente ao final da\n                        compra.")]) : (_vm.newAhesionTaxCont === 0) ? _c('span', [_c('h4', {
    staticClass: "promo-value margin-b10"
  }, [_vm._v("R$ 39,90*")]), _vm._v(" "), _c('b', {
    staticClass: "promo-free"
  }, [_vm._v("Grátis")])]) : _vm._e()]) : _c('span', [_c('h1', {
    staticClass: "bold no-margin margin-b10"
  }, [_vm._v("Grátis")])])]) : _vm._e(), _vm._v(" "), (!_vm.sameTax) ? _c('div', {
    staticClass: "height-82 padding-28"
  }, [_c('p', {
    staticClass: "mob-title-info"
  }, [_vm._v("Adesão Primeiro Veículo")]), _vm._v(" "), _c('h3', {
    staticClass: "bold no-margin"
  }, [_vm._v("\n                      " + _vm._s(_vm._f("cents")(_vm.newAhesionTaxConf)) + "\n                    ")])]) : _vm._e(), _vm._v(" "), (!_vm.sameTax) ? _c('div', {
    staticClass: "height-82 padding-28"
  }, [_c('p', {
    staticClass: "mob-title-info"
  }, [_vm._v("Adesão Veículo Adicional")]), _vm._v(" "), _c('h3', {
    staticClass: "bold no-margin"
  }, [_vm._v("\n                      " + _vm._s(_vm._f("cents")(_vm.newVehicleTaxConf)) + "\n                    ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "height-72 padding-t25"
  }, [_c('a', {
    directives: [{
      name: "smooth-scroll",
      rawName: "v-smooth-scroll"
    }],
    staticClass: "make-link",
    attrs: {
      "href": "#rechargeB2B"
    }
  }, [_vm._v("\n                      Veja Nossas Taxas de Recarga\n                    ")])]), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "row-button border-radius-bottom"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "tag": "button"
    },
    on: {
      "click": function($event) {
        return _vm.choose(22)
      }
    }
  }, [_vm._v("\n                      Quero este plano!\n                    ")])])])])])])])])])]), _vm._v(" "), _c('card-taxes', {
    attrs: {
      "showTaxes": 'pf'
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-72 border-radius-top"
  }, [_c('p', {
    staticClass: "margin-10"
  }, [_c('i', {
    staticClass: "icon-plans icon-plans-table"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-112"
  }, [_c('p', {
    staticClass: "bold no-margin padding-t35"
  }, [_vm._v("Como Funciona?")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-72"
  }, [_c('p', {
    staticClass: "bold no-margin padding-23"
  }, [_vm._v("Taxas")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-82"
  }, [_c('p', {
    staticClass: "bold no-margin padding-10"
  }, [_vm._v("Formas de Pagamento")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-82"
  }, [_c('p', {
    staticClass: "bold no-margin"
  }, [_vm._v("Pode receber Vale-pedágio?")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-72 border-radius-top"
  }, [_c('h3', {
    staticClass: "sub-title plan upper no-margin margin-b10"
  }, [_vm._v("\n                      Pré-pago Manual\n                    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-112"
  }, [_c('p', {
    staticClass: "mob-title-info"
  }, [_vm._v("Como funciona?")]), _vm._v(" "), _c('p', {
    staticClass: "no-margin paragrafo-plano"
  }, [_vm._v("\n                      Excelente para você que quer ter controle total dos seus\n                      gastos e tem tempo para planejar as suas recargas.\n                    ")]), _vm._v(" "), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-82 padding-23"
  }, [_c('p', {
    staticClass: "mob-title-info"
  }, [_vm._v("Formas de Pagamento")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Cartão de Crédito")]), _vm._v(" "), _c('li', [_vm._v("Pix")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-82 padding-28"
  }, [_c('p', {
    staticClass: "mob-title-info"
  }, [_vm._v("Pode receber Vale-pedágio?")]), _vm._v(" "), _c('ul', [_c('p', [_vm._v("Sim")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-72 border-radius-top"
  }, [_c('h3', {
    staticClass: "sub-title plan upper no-margin margin-b10"
  }, [_vm._v("\n                      Pré-pago Automático\n                    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-112 height-72-big padding-18"
  }, [_c('p', {
    staticClass: "mob-title-info"
  }, [_vm._v("Como funciona?")]), _vm._v(" "), _c('p', {
    staticClass: "no-margin paragrafo-plano"
  }, [_vm._v("\n                      Perfeito para você que gosta de comodidade e não quer se\n                      preocupar com recargas ou saldo insuficiente.\n                    ")]), _vm._v(" "), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-82 padding-23"
  }, [_c('p', {
    staticClass: "mob-title-info"
  }, [_vm._v("Formas de Pagamento")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Cartão de Crédito")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-82 padding-28"
  }, [_c('p', {
    staticClass: "mob-title-info"
  }, [_vm._v("Pode receber Vale-pedágio?")]), _vm._v(" "), _c('ul', [_c('p', [_vm._v("Sim")])])])
}]}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-51f43f5a!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/external/plans/b2c.vue
// module id = 2126
// module chunks = 1